import {Component, Input, OnInit} from '@angular/core';
import {ContactPensionProductsPreviewModel} from '../contact-pension-products-preview-model';

@Component({
  selector: 'cf-contact-pension-preview',
  templateUrl: './contact-pension-preview.component.html',
  styleUrls: ['./contact-pension-preview.component.scss'],
})
export class ContactPensionPreviewComponent implements OnInit {

  @Input()
  contactPreviewModel: ContactPensionProductsPreviewModel;

  @Input()
  showContactHeader = true;

  @Input()
  showProgression = true;
  @Input()
  showProgressionText = true;
  @Input()
  showProgressionBar = true;

  @Input()
  showCharts = true;
  @Input()
  showChartsLegend = true;
  @Input()
  showChartsLegalStrings = true;

  constructor() {
  }

  ngOnInit(): void {
  }

}
